import React from "react";
import { DEVELOPMENT, DEFAULT_ENV } from "../../constants";

const EnvironmentSelector = ({ onChange, value = DEFAULT_ENV }) => {
  return (
    <div>
      <label style={{ marginRight: "10px" }}>Environment:</label>
      <select
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
        }}
      >
        {DEVELOPMENT && <option value="development">Development</option>}
        <option value="staging">Staging</option>
        <option value="validation">Validation</option>
        <option value="production">Production</option>
      </select>
    </div>
  );
};

export default EnvironmentSelector;
